import $ from "jquery";

import randomPassword from "../lib/randomPassword";

$(() => {
  document.querySelectorAll(".random-password").forEach((elem) => {
    const inputs = elem.querySelectorAll("input");

    elem.querySelectorAll(".generate-password").forEach((link) => {
      link.addEventListener("click", (evt) => {
        evt.preventDefault();
        const password = randomPassword();
        inputs.forEach((input) => (input.value = password));
      });
    });
  });
});
